<template>
  <div>
    <v-card outlined class="pb-2">
      <v-card-title v-if="show_title" class="primary--text text-subtitle-2 overline d-flex justify-space-between pb-0">
        <span>Informação do lançamento</span>
      </v-card-title>
      <v-card-text class="mt-2 pb-1">
        <v-form ref="form_register_movement" class="pt-2" 
          v-model="valid" @submit.prevent="submitMovement" :readonly="!is_editing && editing_movement"
        >
          <card-loading-transparent v-if="loading"/>

          <template v-if="(!loading && (editing_movement || create_movement || create_event_movement))">
            <v-row class="pa-0" align="center">
              <!-- <v-col  cols='12' sm='4' class="py-2"  v-if="is_event_mov && ((movement_to_edit && movement_to_edit.account_kind == 'savings') || !movement_to_edit)">
                <v-select :menu-props="{ bottom: true, offsetY: true }" outlined dense :items="all_account_kinds" label="Tipo de conta" v-model="movement.account_kind" :rules="required" :disabled="!is_editing && editing_movement"></v-select>
              </v-col> -->
              <v-col cols='12' sm='4' class="py-2">
                <v-select :menu-props="{ bottom: true, offsetY: true }" outlined dense :items="all_kinds" label="Tipo de lançamento" v-model="movement.kind" :rules="required" :disabled="!is_editing && editing_movement || !is_event_mov"></v-select>
              </v-col>
              <v-col cols='12' sm='4' class="py-2">
                <v-text-field outlined dense label="Nome" v-model="movement.name" :rules="movement_to_edit != {} ? required : ''" :disabled="!is_editing && editing_movement || !is_event_mov"></v-text-field>
              </v-col>
              <v-col cols='12' sm='4' class="py-2">
                <v-text-field outlined dense v-model="movement.value" label="Valor" v-currency='currency' prefix="R$" :rules="required" :disabled="!is_editing && editing_movement || !is_event_mov"></v-text-field>
              </v-col>
              <v-col cols='12' sm='4' class="py-2">
                <v-select :menu-props="{ bottom: true, offsetY: true }" outlined dense :items="category_items" label="Categoria" v-model="movement.category" :rules="required" :disabled="(!is_editing && editing_movement || !is_event_mov) "></v-select>
              </v-col>

              <v-col v-if="movement.account_kind != 'savings'" cols='12' sm='4' class="py-2">
                <v-select :menu-props="{ bottom: true, offsetY: true }" outlined dense :items="all_statuses" label="Status" v-model="movement.status" :rules="required" :disabled="!is_editing && editing_movement"></v-select>
              </v-col>
              
              <v-col cols='12' sm='4' class="py-2" v-if="can_show_date">
                <calendar-date-picker  label="Vencimento"  is_component_show_event
                  @datePicked="handleDueDate"
                  :date="movement.due_date"
                  :is_readonly="!is_editing && editing_movement || !is_event_mov"
                ></calendar-date-picker>
              </v-col>
              
              <v-col cols='12' sm='12' class="py-0">
                <v-textarea outlined dense v-model="movement.description" label="Descrição" :disabled="!is_editing && editing_movement || !is_event_mov"></v-textarea>
              </v-col>

              <v-col v-if="movement.account_kind != 'savings'" cols='12' sm='12' class="align-self-start py-0 pr-3">
                <!-- anexo -->
                <v-btn 
                  dense small style="background-color: rgba(63, 167, 255, 0.3);"
                  v-if="!is_editing || (!is_editing && movement.receipt_image_url)" 
                  @click="receipt_image_dialog = !receipt_image_dialog" 
                  :disabled="!movement.receipt_image_url"
                ><v-icon left>mdi-file</v-icon>Abrir anexo</v-btn>
                <dialog-show-file                   
                  title="Anexo" 
                  :file_url="movement.receipt_image_url" 
                  :file_kind="movement.receipt_image_url" 
                  :dialog_file="receipt_image_dialog" 
                  @closeDialog="receipt_image_dialog = !receipt_image_dialog"
                ></dialog-show-file>

                <v-file-input v-if="is_editing || (is_editing && !movement.receipt_image_url)" dense :disabled="!is_editing && editing_movement" label='Anexar' show-size outlined v-model="receipt_image" ></v-file-input>
                <!-- fim anexo -->
              </v-col>

              <v-col v-if="movement_to_edit && movement_to_edit.status == 'payed'" cols='12' class="py-2">
                <span class="font-weight-bold">Executado em: </span>
                {{ $dayjs(movement_to_edit.done_at).format('LLLL') }}
              </v-col>
            </v-row>
            
            <v-row class="justify-end mt-6" >  
              <v-btn v-if="!is_editing && !editing_movement" :disabled="!valid" type="submit" small dense text class="mb-4 mr-2 btn-success">Salvar</v-btn>
              <!-- <v-btn v-if="is_editing" :disabled="!valid" color="primary" class="mb-4 mr-10" @click="submitMovement">Editando</v-btn> -->
            </v-row>
          </template>
        </v-form>  
      </v-card-text>
    </v-card>
    <v-row class="mt-2">
      <v-col cols='8' class="pa-0 px-4 d-flex justify-start" >
        <template v-if="can_edit">
          <v-btn @click="setEditOrCancel" small dense text
            v-if="movement.id"
            :class="!is_editing ? 'mb-4 mr-2 btn-primary' : 'mb-4 mr-2 btn-error'"
            :disabled="loading"
          >
            <v-icon left>{{!is_editing ? 'mdi-pencil' : 'mdi-cancel'}}</v-icon>
            {{!is_editing ? 'Editar' : 'Cancelar'}} 
          </v-btn>
          <v-btn type="submit" @click="submitMovement" v-if="is_editing" small dense text class="mb-4 mr-2 btn-success">
            <v-icon left>mdi-content-save</v-icon>Salvar  
          </v-btn>
        </template>
      </v-col>

        
      <v-col cols='4' class="pa-0 d-flex flex-row-reverse px-4" v-if="can_delete">
        <v-btn :disabled="is_editing" type="submit" @click="dialog_delete = true" small dense text class="mb-4 mr-0 btn-error">
          <v-icon left>mdi-delete</v-icon>Excluir  
        </v-btn>
      </v-col>
    </v-row>
    <dialog-loading v-if="saving" loadingText='Salvando'></dialog-loading>

    <v-dialog v-model="dialog_delete" persistent max-width="500px" class="d-flex justify-center">
      <v-card>
        <v-card-title primary-title class='text-card'>
          Alerta!
        </v-card-title>
        <v-card-text class="mt-6">
          <div class="text-subtitle-1">
            Deseja excluir permanentemente este lançamento ?
          </div>
          <div class="pa-2 pt-6 d-flex justify-center">
            <v-btn color="red white--text" @click="deleteMovement()"><v-icon>mdi-check</v-icon> Confirmar</v-btn>
            <v-btn color="primary" class="ml-2" @click="dialog_delete = false"><v-icon>mdi-cancel</v-icon> Cancelar </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
  import validations from "@/mixins/validations";
  import {CurrencyDirective} from 'vue-currency-input';
  import Api from '@/api';
  import { mapState, mapActions } from 'vuex'

  export default {
    name: 'FormRegisterMovement',
    mixins: [ validations ],
    directives: {
      currency: CurrencyDirective,
    },
    components: {
      CalendarDatePicker: () => import ('@/components/events_agenda/calendar/CalendarDatePicker')
    },
    props: {
      editing_movement: {
        type: Boolean,
        default: false
      },
      create_movement: {
        type: Boolean,
        default: false
      },
      create_event_movement: {
        type: Boolean,
        default: false
      },
      movement_to_edit: {
        type: Object,
        default: ()=> {}
      },
      show_title: {
        type: Boolean,
        default: true
      },
      is_component_used_to_create_an_expense: {
        type: Boolean,
        default: false
      },
      is_component_used_to_edit_an_parcel: {
        type: Boolean,
        default: false
      },
    },
    data() {
      return {
        currency:{
          currency: null,
          locale: 'en-EN',
          autoDecimalMode: true,
          decimalLength: 2,
          distractionFree:false,
        },
        receipt_image_dialog: false,
        all_account_kinds: [
          {text: 'Conta Corrente', value: 'current'},
          {text: 'Conta Poupança', value: 'savings'},
          // {text: 'Reserva', value: 'savings'},
        ],
        all_statuses: [
          { text: 'Pendente', value: 'open'},
          { text: 'Executado', value: 'payed'},
          { text: 'Atrasado', value: 'overdue'},
        ],
        category_items: [
          { text: 'Alimentação', value: 'food'},
          { text: 'Transporte', value: 'transport'},
          { text: 'Marketing', value: 'marketing'},
          { text: 'Investimento', value: 'investment'},
          { text: 'Impostos', value: 'taxes'},
          { text: 'Operacionais', value: 'operational'},
          { text: 'Bonificação', value: 'bonus'},
          { text: 'Outro', value: 'other'},
        ],
        all_kinds: [
          { text: 'Entrada', value: 'income'},
          { text: 'Saída', value: 'outcome'},
          { text: 'Retirada', value: 'withdraw'},
        ],
        saving: false,
        loading: false,
        is_editing: false,
        dialog_delete: false,
        valid: true,
        movement: {
          id: null,
          name: '',
          description: '',
          kind: '', // income / outcome
          category: '',
          status: '', // status: {open: 1, payed: 10, overdue: 20, canceled: 30}
          account_kind: 'current', // current / savings
          due_date: '',
          company_id: this.activeCompanyId,
          receipt_image_url: null, 
          value: '', 
          event_id: null,
        },
        receipt_image: null,
      }
    },
    methods: {
      handleDueDate(v){
        this.movement.due_date = v
      },
      submitMovement(){
        let movement = this.prepareMovement()
        let ACTION = {
          method: this.movement.id ? 'updateFormData' : 'createFormData', // updateFormData,
          data: movement
        }
        this.saveMovement(ACTION)
      },
      deleteMovement(){   
        this.dialog_delete = false     
        this.saving = true

        Api.Movement.delete(this.movement_to_edit.id).then( () =>{
          this.addNotification({type: 'success', msg: 'Excluido com sucesso'})
        }).catch((err) =>{
          this.addNotification({type: 'error', msg: `Erro: ${err}`})
        }).finally(() => {
          this.is_editing = false
          this.saving = false
          this.$emit('done')
        })
      },
      prepareMovement(){
        var formData = new FormData();

        if(this.movement.id){
          formData.append("movement[id]",this.movement.id || null)
        }
        //formData.append("movement[status]",this.status)
        formData.append("movement[name]",this.movement.name)
        formData.append("movement[is_an_expense]",this.is_component_used_to_create_an_expense)
        if(this.create_event_movement || this.editing_movement ? this.editing_movement.id || this.$route.params.id : null){
          formData.append("movement[event_id]",this.create_event_movement || this.editing_movement ? this.movement.id || this.$route.params.id : null)
        }
        formData.append("movement[value]",Math.round(Number(this.movement.value.replace(/,/g, '') )*100))
        formData.append("movement[description]",this.movement.description)
        formData.append("movement[kind]",this.movement.kind)
        formData.append("movement[category]",this.movement.category)
        formData.append("movement[account_kind]",this.movement.account_kind)
        formData.append("movement[status]",this.account_kind != 'savings' && !this.movement_to_edit ? this.movement.status : this.movement_to_edit ? this.movement.status : 'payed')
        formData.append("movement[done_at]", this.$dayjs().toISOString())
        formData.append("movement[company_id]",this.activeCompanyId)
        formData.append("movement[due_date]",this.can_show_date? this.movement.due_date : this.$dayjs().endOf('day').toISOString())
        if(this.receipt_image){
          formData.append("movement[receipt_image]",this.receipt_image || null)
        }

        return formData
      },
      setEditOrCancel(){
        if(this.is_editing){
          this.setMovement(this.movement_to_edit)
        }
        this.is_editing = !this.is_editing
      },
      setMovement(movement_item){
        let { value, ...rest } = movement_item
        let formatted_value = (value / 100).toString()
        
        let mov = {
          value: formatted_value,
          company_id: this.activeCompanyId,
          ...rest
        }
        this.movement = mov
      },
      saveMovement(ACTION) {
        if(this.$refs.form_register_movement.validate()){
          this.saving = true

          Api.Movement[ACTION.method](ACTION.data).then( () =>{
            this.addNotification({type: 'success', msg: 'Realizado com sucesso'})
            if(this.create_event_movement){
              this.$emit('movementCreated')
            }
          }).catch((err) =>{
            this.addNotification({type: 'error', msg: `Erro: ${err}`})
          }).finally(() => {
            this.$refs.form_register_movement.reset()
            this.saving = false
            if (ACTION.method == 'updateFormData'){
              this.is_editing = false
              this.$emit('done')
            }
          })
        }
      },
      ...mapActions({
        addNotification: 'Notification/add'
      })
    },
    watch: {
      movement_to_edit(nv) {
        this.setMovement(nv)
      },
      activeCompanyId(){
        if(this.movement_to_edit){
          this.setMovement(this.movement_to_edit)
        }
      }
    },
    mounted () {
      if(this.movement_to_edit){
        this.setMovement(this.movement_to_edit)
      }else{
        this.is_editing = true
      }
    },
    computed: {
      can_show_date(){
        return this.movement_to_edit && this.movement_to_edit.id || this.account_kind != 'savings'
      },
      can_edit(){
        return this.movement_to_edit && (this.movement_to_edit.account_kind != 'savings' && this.movement_to_edit.status != 'payed') || this.$route.name == 'NewMovement' || this.$route.name == 'ShowEvent'
      },
      can_delete(){
        return (this.movement_to_edit && this.movement_to_edit.id >= 0) && (!this.movement_to_edit.event_id || (this.movement_to_edit.event_id && this.movement_to_edit.is_an_expense))
      },
      is_event_mov() {
        if(this.editing_movement){
          return this.movement_to_edit.event_id == null ? true : false
        }else{
          // return (this.movement_to_edit.event_id != null && this.movement_to_edit.is_an_expense == false)
          return true
        }
      },
      ...mapState({
        activeCompanyId: state => state.App.activeCompanyId
      }),
    },
    
  }
</script>

<style lang="scss" scoped>
.input-group--disabled.checkbox .input-group__input {
    color: #000 !important;
}
.theme--light.v-input--is-disabled input{
    color: #000 !important;
}
.theme--light.v-input--is-disabled textarea{
    color: #000 !important;
}

.theme--light.v-input--is-disabled input, .theme--light.v-input--is-disabled textarea{
    color: #000 !important;
}

.v-label--is-disabled{
  color: red !important;
}

input{
  color: red !important;
  padding: 200px
}


.v-text-field__slot{
    color: #000 !important;
}

$text-field-outlined-fieldset-border: 2px solid red !default;
</style>